import fetcher from '../../helpers/fetcher';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import { API_ENDPOINTS } from '../../constants/apiEndpoints';
import { unwrapDataResponse } from '../../utils/unwrapDataResponse';
import type { InspectionQueryParams, InspectionResponse } from '../../types/inspection';

class InspectionService {
  private consumerPriceUrl = ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE;
  private analyticsUrl = ENVIRONMENT_CONFIG.ANALYSIS_SERVICE;

  async getInspections(params: InspectionQueryParams = {}): Promise<InspectionResponse> {
    const queryParams: Record<string, string> = {};

    if (params.page) queryParams.page = params.page.toString();
    if (params.limit) queryParams.limit = params.limit.toString();
    if (params.sortBy) queryParams.sortBy = params.sortBy;
    if (params.sortOrder) queryParams.sortOrder = params.sortOrder;
    if (params.search) queryParams.search = params.search;
    if (params.inspector) queryParams.inspector = params.inspector;
    if (params.establishmentId) queryParams.establishmentId = params.establishmentId.toString();
    if (params.establishmentName) queryParams.establishmentName = params.establishmentName;
    if (params.startTime) queryParams.startTime = params.startTime.toString();
    if (params.endTime) queryParams.endTime = params.endTime.toString();

    const response = await fetcher.get(
      API_ENDPOINTS.INSPECTION.GET_INSPECTION_LIST,
      queryParams,
      undefined,
      this.consumerPriceUrl
    );
    return unwrapDataResponse<InspectionResponse>(response.data);
  }

  async getInspectionCount(
    startTime?: number,
    endTime?: number,
    basketId?: number,
    locationIds?: number[],
    productIds?: number[],
    timezoneOffset?: number
  ): Promise<{ count: number; startTime?: number; endTime?: number }> {
    const queryParams: Record<string, any> = {};

    if (startTime !== undefined && startTime !== null) {
      queryParams.startTime = startTime.toString();
    }

    if (endTime !== undefined && endTime !== null) {
      queryParams.endTime = endTime.toString();
    }

    if (basketId !== undefined && basketId !== null) {
      queryParams.basketId = basketId;
    }

    if (Array.isArray(locationIds) && locationIds.length > 0) {
      queryParams.locationIds = locationIds;
    }

    if (Array.isArray(productIds) && productIds.length > 0) {
      queryParams.productIds = productIds;
    }

    if (timezoneOffset !== undefined && timezoneOffset !== null) {
      queryParams.timezoneOffset = timezoneOffset;
    }

    const response = await fetcher.get(
      API_ENDPOINTS.INSPECTION.GET_PUBLIC_INSPECTION_COUNT,
      queryParams,
      undefined,
      this.analyticsUrl
    );

    return unwrapDataResponse<{ count: number; startTime?: number; endTime?: number }>(
      response.data
    );
  }
}

export const inspectionService = new InspectionService();
